<template>
    <!-- Header -->
    <header id="header" class="header">
        <div class="header-content">
            <div class="container"  style="margin:0;">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="text-container">
                            <h2><span style="font-size:1.0em" class="arcane-font">Spell Slot Tracker</span>
                            <carousel style="padding-top: 0.2em;" :per-page="1" :mouse-drag="false" :autoplay="true" :loop="true" :autoplayTimeout="3000" :paginationEnabled="false" :autoplayHoverPause="false">
                                <slide>
                                    <span id="js-rotating" class="arcane-font">for Adventurers</span>
                                </slide>
                                <slide>
                                    <span id="js-rotating" class="arcane-font">for D&D Players</span>
                                </slide>
                                <slide>
                                    <span id="js-rotating" class="arcane-font">for Druids</span>
                                </slide>
                                <slide>
                                    <span id="js-rotating" class="arcane-font">for Sorcerers</span>
                                </slide>
                                <slide>
                                    <span id="js-rotating" class="arcane-font">for Wizards</span>
                                </slide>
                                <slide>
                                    <span id="js-rotating" class="arcane-font">for Dungeon Masters</span>
                                </slide>
                                <slide>
                                    <span id="js-rotating" class="arcane-font">for New Players</span>
                                </slide>
                                <slide>
                                    <span id="js-rotating" class="arcane-font">for Bards</span>
                                </slide>
                                <slide>
                                    <span id="js-rotating" class="arcane-font">for Spellcasters</span>
                                </slide>
                                <slide>
                                    <span id="js-rotating" class="arcane-font">for Table Top RPGs</span>
                                </slide>
                                <slide>
                                    <span id="js-rotating" class="arcane-font">for Clerics</span>
                                </slide>
                                <slide>
                                    <span id="js-rotating" class="arcane-font">for Game Masters</span>
                                </slide>
                                <slide>
                                    <span id="js-rotating" class="arcane-font">for Paladins</span>
                                </slide>
                                <slide>
                                    <span id="js-rotating" class="arcane-font">for Dice Goblins</span>
                                </slide>
                                <slide>
                                    <span id="js-rotating" class="arcane-font">for Rangers</span>
                                </slide>
                                <slide>
                                    <span id="js-rotating" class="arcane-font">for Visual Learners</span>
                                </slide>
                            </carousel>
                            </h2>
                        
                           <p class="p-large" style="padding-top:1em">
                               Simplify spell slot tracking for your table top adventurer! We will be offering our spell trackers in premium hardwoods. Sign up to get notified when our Kickstarter campaign
                               goes live for <span style="font-size:1.2em; font-weight: bold;">early bird discounts!</span>
                           </p>

                           <img style="width:200px; padding-bottom:0.5em;" src="../assets/images/kickstarter.png"/>
                            <form v-if="!success" id="contactForm" data-toggle="validator" data-focus="false">
                                <!-- <div class="form-group">
                                    <input v-model="email" v-bind:class="[email ? 'notEmpty' : '']" type="email" class="form-control-input" id="cemail" required>
                                    <label class="label-control" for="cemail">Email</label>
                                    <div class="help-block with-errors"></div>
                                </div> -->
                                <div class="form-group">
                                    <button @click="goToKickstarter" type="button" class="btn-solid-lg">View Page</button>
                                </div>
                                <!-- <div class="form-message">
                                    <div id="cmsgSubmit" class="h3 text-center hidden"></div>
                                </div> -->
                            </form>

                            <!-- <div v-if="success" style="color:#05ce78;font-size:1em;">Success! We will contact you when the Kickstarter campaign launches!</div> -->

                            <p class="p-medium">
                                Collaboration with
                                <img style="width:200px; padding-bottom:0.5em;" src="../assets/images/Horizontal DHD Logo for Dark Backgrounds.png"/>
                            </p>
                        </div>
                    </div> <!-- end of col -->
                </div> <!-- end of row -->
                <div class="row">
                    <div class="col-lg-6" style="text-align: center;">
                        <span class="scroll-down">Scroll Down for More <i class="fas fa-arrow-down"/></span>
                    </div>
                </div> 
            </div> <!-- end of container -->
        </div> <!-- end of header-content -->
    </header> <!-- end of header -->
    <!-- end of header -->
</template>

<script>
import api from '@/api'

export default {
  name: 'HeaderSection',
  data() {
      return {
          email: undefined,
          reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
          success: false
      }
  },
  methods: {
    isEmailValid() {
        return (this.email == "")? false : (this.reg.test(this.email)) ? true : false;
    },
    storeEmail () {
        if(this.isEmailValid()) {
            api.postEmail(this.email)
            this.success = true
        }
    },
    goToKickstarter () {
        window.open('https://www.kickstarter.com/projects/arcanespectacles/arcane-spectacles-hardwood-spell-trackers', '_blank');
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/HeaderSection.vue